

































































import Vue from 'vue';
import { WorkflowJobTabModel, WorkflowJobTabType, WorkflowStandardProcessingAction, EVENT_BUS } from '@/types';
import WorkflowDynamicForm from '@/components/workflow/WorkflowDynamicForm.vue';
import ManufacturerTab from '@/components/workflow/automotive/tabs/ManufacturerTab.vue';
import DocuSignSignersTab from '@/components/workflow/docuSign/tabs/DocuSignSignersTab.vue';
import ScriveSignersTab from '@/components/workflow/scrive/tabs/ScriveSignersTab.vue';
import PreSalesPackTab from '@/components/workflow/automotive/tabs/PreSalesPackTab.vue';
import PostSalesPackTab from '@/components/workflow/automotive/tabs/PostSalesPackTab.vue';
import { WorkflowFormValidation, workflowTabsHelper } from '@/mixins';
import { mapGetters, mapActions } from 'vuex';
import { EventBus } from '@/classes/EventBus';
import { Components } from '@/customer';

export default Vue.extend({
  name: 'VerticalWorkflowJobTabs',
  mixins: [WorkflowFormValidation, workflowTabsHelper],
  props: {
    processingAction: {
      type: Number,
      validator: (processingAction: number) => WorkflowStandardProcessingAction[processingAction] !== undefined,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isWorkflowJobLocked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeTab: {} as WorkflowJobTabModel,
      loadedTabs: [] as WorkflowJobTabModel[],
      jobTabOrientation: 'vertical'
    };
  },
  methods: {
    ...mapActions('workflowJobStore', ['setActiveVerticalTab']),
    dynamicFormHidden(this: any, key: string): boolean {
      return this.activeVerticalTab.key !== key;
    },
    tabIsStandardOrCustom(this: any, tab: WorkflowJobTabModel) {
      return tab.workflowJobTabType === WorkflowJobTabType.Standard || tab.workflowJobTabType === WorkflowJobTabType.Custom;
    },
    tabHasLoaded(this: any, tab: WorkflowJobTabModel) {
      return this.loadedTabs.includes(tab);
    },
    tabIsPreLoaded(this: any, tab: WorkflowJobTabModel) {
      return tab.preLoad;
    },
    localSetActiveVerticalTab(this: any, tab: WorkflowJobTabModel) {
      if (this.tabIsStandardOrCustom(tab) && !this.loadedTabs.includes(tab) && !this.tabIsPreLoaded(tab)) {
        this.loadedTabs.push(tab);
      }
      this.setActiveVerticalTab(tab.key);
    }
  },
  computed: {
    ...mapGetters('workflowJobStore', ['workflowJob', 'visibleVerticalJobTabs', 'visibleVerticalWorkflowJobTabs', 'workflowDataSources', 'activeVerticalTab']),
    isCancelProcess(this: any): boolean {
      return this.processingAction === WorkflowStandardProcessingAction.CancelJob;
    },
    preloadTabs(this: any): WorkflowJobTabModel[] {
      return this.visibleVerticalJobTabs.filter((x: WorkflowJobTabModel) => x.workflowJobTabType !== WorkflowJobTabType.Workflow && x.preLoad);
    }
  },
  mounted(this: any) {
    this.setActiveVerticalTab();
    if (this.preloadTabs.length < 1) {
      EventBus.$emit(EVENT_BUS.TABS_LOADED, 'vertical');
    } else {
      this.tabs = [...this.preloadTabs.map((tab: WorkflowJobTabModel) => tab.key)];
    }
  },
  components: {
    WorkflowDynamicForm,
    ManufacturerTab,
    DocuSignSignersTab,
    ScriveSignersTab,
    PreSalesPackTab,
    PostSalesPackTab,
    ...Components.VerticalWorkflowJobTabs
  }
});
